import { Info } from 'lucide-react';
import * as React from 'react';

import {
  CHECKOUT_SECTION_CARD,
  EVENT_TERMS_HEADING,
  REFUND_POLICY_HEADING,
  SERVICE_FEE_DISCLOSURE_TEST_ID,
} from './constants';

/**
 * **Event Terms and Conditions** — the refund terms and, on a paid order, the fee disclosure, as
 * one section on the checkout and on the confirmation (TW 44132872).
 *
 * One component on both screens so the two cannot title, order or word the region differently:
 * the section is headed {@link EVENT_TERMS_HEADING}, the policy sits under its own *Refunds*
 * label, and the served disclosure (`MEM-050` AC-2, AC-3) is beneath the policy it goes with.
 *
 * **It composes no copy.** `policySentence` is `refundPolicy?.sentence ?? refundPolicyNotice` off
 * the checkout or the receipt — the event's own terms, the agreed snapshot, or one of the two
 * served absence sentences — and `feeDisclosure` is the served sentence or `null` on a free order
 * (`MEM-050` AC-4, AC-5). Where the section sits is each screen's decision; see the checkout.
 */
export function EventTermsPanel({
  policySentence,
  feeDisclosure,
}: {
  readonly policySentence: string;
  readonly feeDisclosure: string | null;
}): React.ReactElement {
  return (
    <section className={`${CHECKOUT_SECTION_CARD} space-y-2`}>
      <h2 className="font-brand text-md font-bold text-foreground">{EVENT_TERMS_HEADING}</h2>
      <div className="space-y-1.5">
        <h3 className="font-brand text-sm font-bold text-foreground">{REFUND_POLICY_HEADING}</h3>
        <p className="flex items-start gap-2 text-sm text-muted-foreground">
          <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
          <span>{policySentence}</span>
        </p>
        {feeDisclosure === null ? null : (
          <p data-testid={SERVICE_FEE_DISCLOSURE_TEST_ID} className="pl-6 text-sm text-text-body">
            {feeDisclosure}
          </p>
        )}
      </div>
    </section>
  );
}
